<template>
  <v-form-group class="c-widget-input-search" :label="label" :label-for="id">
    <v-form-text
      autocomplete="off"
      :clearLabel="i18n('clear', 'components.widgetInputText')"
      :id="id"
      :placeholder="placeholder || $t('white-label.globalLabels.symbolPlaceholder')"
      :value="value"
      @clear="$emit('input', '')"
      @input="$emit('input', $event)"
    >
      <template v-slot:prepend>
        <span>
          <i class="fas fa-search" aria-hidden="true" />
        </span>
      </template>
      <template v-slot:dropdown>
        <v-button v-if="powerUser" @click="searchOrderDetails()" class="btn-append">{{
          $t('white-label.globalLabels.search')
        }}</v-button>
      </template>
    </v-form-text>
  </v-form-group>
</template>

<script>
export default {
  name: 'c-widget-input-search',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    powerUser: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  computed: {
    id() {
      return `c-widget-input-search-${this._uid}`;
    }
  },
  methods: {
    searchOrderDetails() {
      this.$emit('searchOrderDetails');
    },
    i18n(subkey, ns = 'components.widgetInputSearch') {
      return this.$t(`white-label.${ns}.${subkey}`);
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-widget-input-search';
</style>
